export default __webpack_public_path__ + "static/media/Plus.1ada2a38.svg";